export default "__VITE_ASSET__LuaXa4wG__"